import {
  View,
  Text,
  Animated,
  ScrollView,
  Pressable,
  FlatList,
  TouchableOpacity,
  Image,
} from "react-native";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { RootState, dispatch, useSelector } from "../../../redux/store";
import dimensions from "../../../globalStyles/dimensions";
import {
  fetchExperience,
  resetExperience,
} from "../../../redux/experience/experienceSlice";
import { LinearGradient } from "expo-linear-gradient";
import CancelConfirmationModal from "../../../modal/BookingModals/CancelConfirmationModal";
import AwaitingConfirmationModal from "../../../modal/BookingModals/AwaitingConfirmationModal";
import { Colors } from "../../../globalStyles/ColorConfig";
import { BlurView } from "expo-blur";
import FeedIcons from "../../../assets/Icons/FeedIcons";
import Carousel from "../Experience/components/generalComponents/Carousel";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import BookingMiniCard from "./components/BookingMiniCard";
import IncludeComponent from "../Experience/components/generalComponents/IncludeComponent";
import PriceDetails from "./components/PriceDetails";
import ExperienceIcons from "../../../assets/Icons/ExperienceIcons";
import StaticImages from "../../../assets/StaticImages";

export default function BookingDetails({ route }: { route: any }) {
  const { userToken } = useSelector((state: RootState) => state.user);
  const navigation = useNavigation();
  const { _id: experienceID } = route.params;
  const { status } = route.params;
  const { singleBookingData } = route.params;

  const [active, setActive] = useState(false);

  const scrollY = useRef(new Animated.Value(0)).current;

  const translateY = useRef(new Animated.Value(0)).current;

  const handleScroll = useCallback(
    (event: any) => {
      const scrollOffset = event.nativeEvent.contentOffset.y;
      if (scrollOffset > 500) {
        Animated.timing(translateY, {
          toValue: dimensions.windowHeight / 11,
          duration: 200,
          useNativeDriver: true,
        }).start();
      } else {
        Animated.timing(translateY, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        }).start();
      }
    },
    [translateY]
  );

  // const [choosedate, setChoosedate] = useState<string | null>(null);
  const [includeModal, setIncludeModal] = useState(false);

  const [visible, setVisible] = useState(false);
  const [cancel, setCancel] = useState(false);

  const handleToggle = () => {
    setVisible(!visible);
  };

  const handleCancel = () => {
    setCancel(!cancel);
  };

  const handleIncludeModal = useCallback(() => {
    setIncludeModal((prevState) => !prevState);
  }, []);

  const {
    experience: responseData,
    isLoading,
    error,
  } = useSelector((state: RootState) => state.experience);

  const [experienceData, setExperienceData] = useState<{
    longitude?: any;
    latitude?: any;
    label?: string;
    mapType?: string;
    reviews?: any;
    included?: any;
    schedulesAvailable?: any;
    mediaUrls?: string[];
    price?: number;
  }>({});

  useEffect(() => {
    if (!isLoading && responseData) {
      const videoUrls =
        responseData?.media.videos?.map((video: any) => video.url) || [];
      const imageUrls =
        responseData?.media.images?.map((image: any) => image.url) || [];

      const mediaUrls: any = [
        ...videoUrls.filter((url: any) => url), // Filter out empty string URLs
        ...imageUrls.filter((url: any) => url), // Filter out empty string URLs
      ];

      setExperienceData({
        longitude: responseData?.location?.longitude,
        latitude: responseData?.location?.latitude,
        label: responseData?.location?.name,
        mapType: "standard",
        reviews: responseData?.rating,
        included: responseData?.includedPackages,
        schedulesAvailable: responseData?.schedulesAvailable,
        mediaUrls: mediaUrls.length > 0 ? mediaUrls : null,
        price: responseData?.price,
      });
    }
    // });
  }, [isLoading, responseData]);

  const fetchExperienceData = useCallback(() => {
    // InteractionManager.runAfterInteractions(() => {
    dispatch(fetchExperience({ authToken: userToken, experienceID }));
    // });
  }, [userToken, experienceID]);

  useEffect(() => {
    fetchExperienceData();
  }, [fetchExperienceData]);

  const pressBackArrow = () => {
    dispatch(resetExperience());
    navigation.goBack();
  };

  if (error) {
    return <Text>Got Error</Text>;
  }

  if (isLoading && !responseData) {
    // return <AllExperienceLoader/>
    return <Text>Loading...</Text>;
  }

  if (!isLoading && !responseData && !responseData?.length) {
    return <Text>Data Empty...</Text>;
  }
  return (
    <>
      <CancelConfirmationModal visible={cancel} toggleModal={handleCancel} />
      {status === "confirmed" ? (
        //
        <></>
      ) : status === "pending" ? (
        <AwaitingConfirmationModal
          visible={visible}
          toggleModal={handleToggle}
        />
      ) : null}

      <LinearGradient
        colors={["rgba(0,0,0,0.9)", "transparent"]}
        style={{
          position: "absolute",
          width: dimensions.windowWidth,
          height: dimensions.windowHeight / 16,
          top: 0,
          zIndex: 1,
        }}
      />
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{ backgroundColor: "#fff" }}
        scrollEventThrottle={12}
        onScroll={Animated.event(
          [{ nativeEvent: { contentOffset: { y: scrollY } } }],
          { useNativeDriver: false, listener: handleScroll }
        )}
      >
       <BlurView
          tint="dark"
          style={{
            position: "absolute",
            zIndex: 1,
            height: 40,
            width: 40,
            borderRadius: 50,
            overflow: "hidden",
            top: dimensions.windowHeight * 0.05,
            left: dimensions.windowWidth * 0.05,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Pressable onPress={pressBackArrow}>
            <ExperienceIcons.BackArrow />
          </Pressable>
        </BlurView>
        <View
          style={{
            width: dimensions.windowWidth,
            height: dimensions.windowHeight / 2,
          }}
        >
          <Carousel data={experienceData.mediaUrls} status={status} />
        </View>

        <View
          style={{
            paddingVertical: dimensions.paddingVertical,
            paddingHorizontal: dimensions.paddingHorizontal,
          }}
        >
          <CustomComponent.TextView
            title={responseData?.title}
            textStyle={[
                GlobalStyles.title1,
                {
                  fontSize: 26,
                },
              ]}
          />
          <CustomComponent.TextView
            title={responseData?.description}
            textStyle={[
                GlobalStyles.bodyText,
                {
                  opacity: 0.5,
                  fontSize: 14,
                },
              ]}
              boxStyle={{ paddingTop: 5, paddingBottom: 15 }}
          />

          <BookingMiniCard
            data={responseData}
            singleBookingData={singleBookingData}
          />

          <CustomComponent.SolidDivider
            style={{
              width: dimensions.windowWidth / 1.12,
              height: 0.5,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.2,
            }}
          />
          <CustomComponent.TextView
            title="What’s included"
            textStyle={[
                GlobalStyles.title1,
                {
                  fontSize: 26,
                },
              ]}
              boxStyle={{ paddingVertical: 10 }}
          />
        </View>

        <FlatList
          data={experienceData.included}
          keyExtractor={(item) => item._id}
          renderItem={(item) => (
            <IncludeComponent item={item} toggle={handleIncludeModal} />
          )}
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{
            gap: 10,
            paddingVertical: dimensions.paddingVertical / 2,
            paddingHorizontal: dimensions.paddingHorizontal,
          }}
        />
        <View
          style={{
            paddingTop: dimensions.paddingVertical,
            paddingHorizontal: dimensions.paddingHorizontal,
          }}
        >
          <CustomComponent.SolidDivider
            style={{
              width: dimensions.windowWidth / 1.12,
              height: 0.5,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.2,
            }}
          />
         <CustomComponent.TextView
            title="Where will you both be"
            textStyle={[
              GlobalStyles.title1,
              {
                fontSize: 26,
              },
            ]}
            boxStyle={{ paddingVertical: 10 }}
          />
          {/* <StaticImages.Map /> */}
          <Image
            source={StaticImages.Map}
            style={{
              width: dimensions.windowWidth / 1.12,
              height: dimensions.windowHeight / 3,
              borderRadius: 10,
              marginTop: 5,
              marginBottom: 10,
            }}
          />
          {/* {experienceData?.latitude && experienceData?.longitude && (
            <Pressable onPress={openMapsApp}>
            {(Platform.OS==="ios" || Platform.OS==="android") && <MapComponent
              initialLatitude={experienceData?.latitude}
              initialLongitude={experienceData?.longitude}
            />}
            </Pressable>
          )} */}

          <CustomComponent.SolidDivider
            style={{
              width: dimensions.windowWidth / 1.12,
              height: 0.5,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.2,
            }}
          />
          <CustomComponent.SolidDivider
            style={{
              width: dimensions.windowWidth / 1.12,
              height: 0.5,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.2,
              marginTop: dimensions.marginVertical * 3,
            }}
          />

          <PriceDetails price={responseData?.price} />
        </View>

        <View
          style={{
            paddingTop: dimensions.paddingVertical,
            paddingHorizontal: dimensions.paddingHorizontal,
          }}
        >
          <CustomComponent.SolidDivider
            style={{
              width: dimensions.windowWidth / 1.12,
              height: 0.5,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.2,
              marginVertical: dimensions.marginVertical,
            }}
          />
          <TouchableOpacity
            onPress={() => {}}
            style={{ paddingVertical: dimensions.paddingVertical / 2 }}
          >
            <CustomComponent.TextView
              title="Cancellation policy"
              textStyle={[GlobalStyles.cancellationPolicy, { lineHeight: 52 }]}
            />
            <CustomComponent.TextView
              title="Cancel 24 hours before the start time for the refund"
              textStyle={GlobalStyles.bodyText}
            />
          </TouchableOpacity>
          <CustomComponent.SolidDivider
            style={{
              width: dimensions.windowWidth / 1.12,
              height: 0.5,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.2,
              marginVertical: dimensions.marginVertical * 2,
            }}
          />
        </View>

        <View
          style={{
            alignSelf: "center",
            backgroundColor: "#1F3930",
            width: "91%",
            borderRadius: 60,
          }}
        >
          <Pressable onPress={handleToggle}>
            <Text
              style={[
                GlobalStyles.rescheduleBookings,
                { lineHeight: 42, alignSelf: "center", padding: 10 },
              ]}
            >
              Reschedule booking
            </Text>
          </Pressable>
        </View>
        <View
          style={{
            width: dimensions.windowWidth,
            marginVertical: dimensions.marginVertical,
          }}
        >
          <Pressable onPress={handleCancel}>
            <Text
              style={[
                GlobalStyles.bodyText,
                { lineHeight: 42, alignSelf: "center", padding: 10 },
              ]}
            >
              Cancel booking
            </Text>
          </Pressable>
        </View>
      </ScrollView>
    </>
  );
}
